export default __webpack_public_path__ + "static/media/Water-TowerFrame.1caa1523.jpg";